import * as React from "react";
import {
  OriginThemeProvider,
  TrackingProvider,
} from "@origin-digital/ods-core";
import { trackingProviderCaptureClick } from "@origin-digital/reporting-client";
import { BrowserRouter } from "react-router-dom";
import { FeatureFlagContextProvider } from "@origin-digital/feature-flags";
import { PrefetchSpecs } from "@origin-digital/tal-fe";
import { AppContextProvider } from "./AppContext";
import { Router } from "./router";
import { PrefetchContext } from "./helpers/usePrefetched";
import { config } from "./config";

export default (props: {
  envConfig: IAppConfig;
  prefetchContent: PrefetchSpecs;
}) => {
  return (
    <OriginThemeProvider enableThemeSwitching>
      <TrackingProvider onTrackingCapture={trackingProviderCaptureClick}>
        <PrefetchContext.Provider value={props.prefetchContent}>
          <AppContextProvider config={props.envConfig}>
            <FeatureFlagContextProvider featureFlags={config.featureFlags}>
              <BrowserRouter>
                <Router />
              </BrowserRouter>
            </FeatureFlagContextProvider>
          </AppContextProvider>
        </PrefetchContext.Provider>
      </TrackingProvider>
    </OriginThemeProvider>
  );
};
